import React from "react";
import LendbotDisabled from "@app/app/modules/assets/svg/lendbotDisabled";
import GetDataDisabled from "@app/app/modules/assets/svg/getDataDisabled";
import TouDisabled from "@app/app/modules/assets/svg/touDisabled";
import ConsentDisabled from "@app/app/modules/assets/svg/consentDisabled";
import ConnectDisabled from "@app/app/modules/assets/svg/connectDisabled";
import AccordDisabled from "@app/app/modules/assets/svg/accordDisabled";
import JscypherDisabled from "@app/app/modules/assets/svg/jscypherDisabled";
import LendbotEnabled from "@app/app/modules/assets/svg/lendbotEnabled";
import GetDataEnabled from "@app/app/modules/assets/svg/getDataEnabled";
import TouEnabled from "@app/app/modules/assets/svg/touEnabled";
import ConsentEnabled from "@app/app/modules/assets/svg/consentEnabled";
import ConnectEnabled from "@app/app/modules/assets/svg/connectEnabled";
import AccordEnabled from "@app/app/modules/assets/svg/accordEnabled";
import JscypherEnabled from "@app/app/modules/assets/svg/jscypherEnabled";

const disabledIconsMap = {
  getdata: <GetDataDisabled />,
  lendbot: <LendbotDisabled />,
  accord: <AccordDisabled />,
  connect: <ConnectDisabled />,
  consent: <ConsentDisabled />,
  tou: <TouDisabled />,
  jscipher: <JscypherDisabled />,
};

const enabledIconsMap = {
  getdata: <GetDataEnabled />,
  lendbot: <LendbotEnabled />,
  accord: <AccordEnabled />,
  connect: <ConnectEnabled />,
  consent: <ConsentEnabled />,
  tou: <TouEnabled />,
  jscipher: <JscypherEnabled />,
};

const appsPathMap = {
  getdata: "/getdata",
  lendbot: "/lendbot",
  fleet: "/fleet"
};

const toolsPathMap = {
  accord: "/accord",
  connect: "/connect",
  facesign: "/facesign",
  consent: "/consents",
  tou: "/tous",
  jscipher: "/jscipher",
  vizdata: "/vizdata"
};

function addNewKeys(product) {
  if (product.type === "app") {
    return {
      path: appsPathMap[product.code],
      active: false,
      enabledIcon: enabledIconsMap[product.code],
      disabledIcon: disabledIconsMap[product.code],
      ...product,
    };
  }
  return {
    path: toolsPathMap[product.code],
    active: false,
    enabledIcon: enabledIconsMap[product.code],
    disabledIcon: disabledIconsMap[product.code],
    ...product,
  };
}

export default function getAppToolProducts(products) {
  let currentProducts = {};
  let enabledApps = [];
  let disabledApps = [];
  let enabledTools = [];
  let disabledTools = [];
  products.forEach((product) => {
    if (product.type === "app") {
      if (product.enabled && product.status === "Enabled") {
        enabledApps.push(addNewKeys(product));
      } else {
        disabledApps.push(addNewKeys(product));
      }
    } else {
      if (product.enabled && product.status === "Enabled") {
        enabledTools.push(addNewKeys(product));
      } else {
        disabledTools.push(addNewKeys(product));
      }
    }
  });
  currentProducts["app"] = [...enabledApps, ...disabledApps];
  currentProducts["tool"] = [...enabledTools, ...disabledTools];
  return currentProducts;
}
